import { device } from "@utils";
import { Layout } from "antd";
import styled from "styled-components";
const { Header } = Layout;

export const StyledHeader = styled(Header)`
  display: flex;
  align-items: center;
  column-gap: 2rem;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  line-height: normal;
  height: 60px;
  h4 {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 30px;
    display: flex;
    align-items: center;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #000000;
  }
  .logo {
    display: flex;
  }
  .profile {
    display: flex;
    column-gap: 14px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        display: flex;
        align-items: center;
        letter-spacing: 0.02em;
        color: #555555;
      }
      a {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.02em;
        text-decoration-line: underline;
      }
    }
  }
  @media ${device.tablet} {
    height: 70px;
    padding: 16px 20px;
    h4 {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 30px;
      display: flex;
      align-items: center;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: #000000;
    }
  }
`;
